import Button from '@mui/material/Button';
import { Translate } from '@shared/translation';
import { Table } from '@tanstack/react-table';
import { BodyCell } from '../../components/BodyCell';
import { TableRow } from '../../components/TableRow';
import { useDataProvider } from '../../DataProviderContext';
import { EmptyState } from '../../internal/EmptyState';
import { useTableTexts } from '../../useTableTexts';

function getIsColumnFilterActive(table?: Table<any>) {
  return table?.getState() && table.getState().columnFilters.length > 0;
}

export const Empty = () => {
  const texts = useTableTexts();
  const { table } = useDataProvider();
  const isColumnFilterActive = getIsColumnFilterActive(table);
  const clearColumnFilters = () => table?.setColumnFilters([]);

  if (!table) {
    return null;
  }

  const enableRowSelection = Boolean(table.options.enableRowSelection);
  const colSpan =
    table.getVisibleFlatColumns().length + (enableRowSelection ? 1 : 0);

  return (
    <TableRow>
      <BodyCell colSpan={colSpan} sx={{ border: 0 }}>
        {isColumnFilterActive ? (
          <EmptyState
            text={texts.emptyWithFilters}
            actions={
              <Button
                color="grey"
                variant="contained"
                onClick={clearColumnFilters}
              >
                <Translate text={texts.actions.clearFilters} />
              </Button>
            }
          />
        ) : (
          <EmptyState />
        )}
      </BodyCell>
    </TableRow>
  );
};
